<app-text [alias]="'class_list_data_still_loading'" *ngIf="!isDataLoaded"></app-text>
<app-loading-wrapper [loading]="!isDataLoaded">
    <app-sortable-table *ngIf="displayCourseList?.length > 0 " [data]="displayCourseList">
        <thead>
        <tr>
            <th sortBy="termCode">Term</th>
            <th sortBy="crn">CRN</th>
            <th sortBy="sortCourseId"> Course Section</th>
            <th>Course Title</th>
            <th>Enrollment</th>
            <th>Grades First Submitted</th>
            <th>Grades First Submitted By</th>

        </tr>
        </thead>
        <tbody>

        <tr *ngFor="let element of displayCourseList">
            <td>{{element.termCodeDescription}}</td>
            <td>{{element.crn}}</td>
            <td><a [routerLink]="['roster',element.termCode,element.crn]" (click)="setCurrentCourse(element)">{{element.displayCourseString}}</a></td>
            <td>{{element.courseTitle}}</td>
            <td>{{element.enrollment}}</td>

            <td *ngIf="element.canCourseBeGraded">{{element.gradeFirstSubmittedDate}}</td>
            <td  *ngIf="!element.canCourseBeGraded">Non-Gradable Section</td>

            <td *ngIf="element.canCourseBeGraded">{{element.gradeFirstSubmittedBy}}</td>
            <td  *ngIf="!element.canCourseBeGraded">Non-Gradable Section</td>


        </tr>

        </tbody>
    </app-sortable-table>
    <div *ngIf="displayCourseList?.length === 0  && isDataLoaded ">
        No course data found.
    </div>
</app-loading-wrapper>